export default "__VITE_ASSET__b28363e5__"